import React, { Component } from 'react'
import '../../stylesheets/connor.sass'

export default class Connor extends Component {
  render() {
    return (
      <div className='connor-bg'>
        <div className='main-content'>
          <h1>Connor</h1>
          <p>Coming soon!</p>
        </div>
      </div>
    )
  }
}
